module.exports = __webpack_public_path__ + "img/icon-checkmark-purple.98182ebc.svg";